import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getClient, getIsolationScope } from './currentScopes.js';
import { consoleSandbox } from './utils/debug-logger.js';
import { dateTimestampInSeconds } from './utils/time.js';

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 100;

/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */
function addBreadcrumb(breadcrumb, hint) {
  var client = getClient();
  var isolationScope = getIsolationScope();
  if (!client) return;
  var _client$getOptions = client.getOptions(),
    _client$getOptions$be = _client$getOptions.beforeBreadcrumb,
    beforeBreadcrumb = _client$getOptions$be === void 0 ? null : _client$getOptions$be,
    _client$getOptions$ma = _client$getOptions.maxBreadcrumbs,
    maxBreadcrumbs = _client$getOptions$ma === void 0 ? DEFAULT_BREADCRUMBS : _client$getOptions$ma;
  if (maxBreadcrumbs <= 0) return;
  var timestamp = dateTimestampInSeconds();
  var mergedBreadcrumb = _objectSpread({
    timestamp: timestamp
  }, breadcrumb);
  var finalBreadcrumb = beforeBreadcrumb ? consoleSandbox(function () {
    return beforeBreadcrumb(mergedBreadcrumb, hint);
  }) : mergedBreadcrumb;
  if (finalBreadcrumb === null) return;
  if (client.emit) {
    client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
  }
  isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}
export { addBreadcrumb };